import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IModalData } from '@core/interfaces/imodal-data';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-modal-form',
    templateUrl: './modal-form.component.html',
    styleUrls: ['./modal-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalFormComponent {
  faExclamationTriangle = faExclamationTriangle;

  constructor(public modal: NgbActiveModal, private fb: FormBuilder) {}

  get fileUpload() {
    if (this.data.fileKey) return this.form.get(this.data?.fileKey);
    return null;
  }
  
  form!: FormGroup;
  formSubmitted:boolean = false;

  @Input() data!: IModalData;
  @Output() formChange: EventEmitter<File> = new EventEmitter();
  placeholder!: string;
  defaultText = {
    title: 'Confirm Action',
    body: 'Please confirm your action.',
    cancelBtnText: 'Cancel',
    confirmBtnText: 'Confirm'
  }

  ngOnInit(): void {
    this.initializeForm();
    this.placeholder = this.data.data?.imageFileName ?? this.data.data?.fileName ?? 'Select file...';
  }

  initializeForm(): void {
    if (this.data.formInputs) {
      const formGroupControls: any = {};
      for (const control of this.data.formInputs) {
        const value = (this.data.data && (typeof this.data.data == 'string')) 
          ? this.data.data 
          : (control.controlName && this.data.data)
              ? this.data?.data[control.controlName]
              : null;
        const skipValidation: boolean = Boolean(control.type == 'file' &&
          (this.data?.data?.imageFileName ||
            this.data?.data?.fileName));
        formGroupControls[control.controlName] = [value, ((control.validators && !skipValidation) ? control.validators : null)];
      }
      this.form = this.fb.group(formGroupControls);
      this.form.markAsPristine();
      // this.form.markAsUntouched();
    }
  }

  onInputChange(event: any) {
    if (!event.target.files) return;

    const file: File = event.target.files[0];
    if (file) {
      this.fileUpload?.setValue(file.name);
      this.formChange.emit(file);
      this.form.markAsDirty();
    }
  }
}
